/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Available_And_IncludedInputs */

const en_available_and_included = /** @type {(inputs: Available_And_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Available & Included`)
};

const es_available_and_included = /** @type {(inputs: Available_And_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponible e Incluido`)
};

const fr_available_and_included = /** @type {(inputs: Available_And_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponible & Inclus`)
};

const de_available_and_included = /** @type {(inputs: Available_And_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfügbar & Inbegriffen`)
};

const ja_available_and_included = /** @type {(inputs: Available_And_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`利用可能・追加料金なし`)
};

const zh_available_and_included = /** @type {(inputs: Available_And_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可用且已包含`)
};

const ar_available_and_included = /** @type {(inputs: Available_And_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`متاح ومتضمن`)
};

const id_available_and_included = /** @type {(inputs: Available_And_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tersedia & Termasuk`)
};

const it_available_and_included = /** @type {(inputs: Available_And_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponibile & Incluso`)
};

const ru_available_and_included = /** @type {(inputs: Available_And_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доступен и включен`)
};

const pt_available_and_included = /** @type {(inputs: Available_And_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponível e Incluído`)
};

const ko_available_and_included = /** @type {(inputs: Available_And_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`사용 가능 & 포함됨`)
};

/**
* | output |
* | --- |
* | "Available & Included" |
*
* @param {Available_And_IncludedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const available_and_included = /** @type {((inputs?: Available_And_IncludedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Available_And_IncludedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_available_and_included(inputs)
	if (locale === "es") return es_available_and_included(inputs)
	if (locale === "fr") return fr_available_and_included(inputs)
	if (locale === "de") return de_available_and_included(inputs)
	if (locale === "ja") return ja_available_and_included(inputs)
	if (locale === "zh") return zh_available_and_included(inputs)
	if (locale === "ar") return ar_available_and_included(inputs)
	if (locale === "id") return id_available_and_included(inputs)
	if (locale === "it") return it_available_and_included(inputs)
	if (locale === "ru") return ru_available_and_included(inputs)
	if (locale === "pt") return pt_available_and_included(inputs)
	return ko_available_and_included(inputs)
});